'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

var _bulkUsageData = require('./bulk-usage-data.html');

var _bulkUsageData2 = _interopRequireDefault(_bulkUsageData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _bulkUsageData2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    usages: '<',
    onUsagesSubmitted: '&'
  },
  controller: function () {
    function BulkUsageDataComponent(EventEmitter, UsageDataService) {
      'ngInject';

      _classCallCheck(this, BulkUsageDataComponent);

      Object.assign(this, {
        EventEmitter: EventEmitter,
        UsageDataService: UsageDataService
      });
    }

    _createClass(BulkUsageDataComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.Q4Value = 0;
        this.query = _extends({}, (0, _query.getQuery)(), {
          take: 5
        });
        this.limitOptions = [5, 10, 25, 50];
        this.getQ4Value();
      }
    }, {
      key: 'getQ4Value',
      value: function getQ4Value() {
        var _this = this;

        var promise = this.UsageDataService.getQ4Value(this.usages[0].ProductId, this.usages[0].UsageYear - 1);

        return promise.then(function (result) {
          _this.Q4Value = result.data;
        });
      }
    }, {
      key: 'showWarning',
      value: function showWarning(value1, value2) {
        if ((value1 - value2) / value2 > 1) {
          return true;
        } else if ((value2 - value1) / value1 > 1) {
          return true;
        }
        return false;
      }
    }, {
      key: 'showWarningMessage',
      value: function showWarningMessage() {
        var errors = document.getElementsByClassName('error-icon');
        if (errors.length > 0) {
          if (errors.length === 1 && errors[0].classList[1] === 'warning-message') {
            return false;
          }
          return true;
        }
        return false;
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit() {
        this.onUsagesSubmitted(this.EventEmitter({
          usages: this.usages
        }));
      }
    }]);

    return BulkUsageDataComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/bulk-usage-data/bulk-usage-data.component.js